import React, { useState, useEffect } from 'react';
import './PrincipalDashboard.css';

const PrincipalDashboard = () => {
  // Sample data for tasks
  const [tasks, setTasks] = useState([
    {
      id: 1,
      title: "Board Meeting Preparation",
      description: "Prepare quarterly reports and budget analysis for school management committee",
      date: "2024-12-15",
      time: "09:00",
      priority: "urgent",
      category: "administrative",
      assignee: "self",
      status: "pending",
      assigneeName: "Handle Personally"
    },
    {
      id: 2,
      title: "Teacher Performance Reviews",
      description: "Complete annual performance evaluations for teaching staff",
      date: "2024-12-16",
      time: "14:00",
      priority: "important",
      category: "staff",
      assignee: "hod-english",
      status: "in-progress",
      assigneeName: "Dr. Rajesh Kumar - English HOD"
    },
    {
      id: 3,
      title: "Parent-Teacher Conference Setup",
      description: "Coordinate scheduling and room assignments for PTM",
      date: "2024-12-17",
      time: "10:00",
      priority: "important",
      category: "events",
      assignee: "admin-registrar",
      status: "pending",
      assigneeName: "Mrs. Sunita Verma - Registrar"
    },
    {
      id: 4,
      title: "Fire Safety Drill",
      description: "Conduct monthly emergency evacuation drill as per safety protocols",
      date: "2024-12-15",
      time: "11:00",
      priority: "urgent",
      category: "facilities",
      assignee: "facilities-manager",
      status: "pending",
      assigneeName: "Mr. Suresh Yadav - Facilities Manager"
    },
    {
      id: 5,
      title: "CBSE Curriculum Review",
      description: "Review and approve updated science curriculum as per CBSE guidelines",
      date: "2024-12-18",
      time: "15:30",
      priority: "important",
      category: "academic",
      assignee: "hod-science",
      status: "pending",
      assigneeName: "Dr. Vikram Singh - Science HOD"
    },
    {
      id: 6,
      title: "Student Disciplinary Committee",
      description: "Address behavioral concerns with Grade 10 students and parents",
      date: "2024-12-15",
      time: "13:00",
      priority: "urgent",
      category: "student",
      assignee: "admin-counselor",
      status: "pending",
      assigneeName: "Dr. Arjun Patel - School Counselor"
    },
    {
      id: 7,
      title: "Annual Sports Day Planning",
      description: "Finalize arrangements for inter-house sports competition",
      date: "2024-12-19",
      time: "11:30",
      priority: "normal",
      category: "events",
      assignee: "sports-coordinator",
      status: "pending",
      assigneeName: "Coach Rohit Sharma - Sports Coordinator"
    },
    {
      id: 8,
      title: "Library Digitization Project",
      description: "Review progress of digital catalog implementation",
      date: "2024-12-20",
      time: "16:00",
      priority: "normal",
      category: "facilities",
      assignee: "admin-librarian",
      status: "pending",
      assigneeName: "Ms. Deepika Sharma - Head Librarian"
    }
  ]);

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [modalTitle, setModalTitle] = useState('Add New Task');

  // Upcoming Tasks table filter state (separate from the Add Task modal form)
  const [taskSearch, setTaskSearch] = useState('');
  const [taskPriorityFilter, setTaskPriorityFilter] = useState('');
  const [taskStatusFilter, setTaskStatusFilter] = useState('');
  const [taskAssigneeFilter, setTaskAssigneeFilter] = useState('');
  const [taskDateStart, setTaskDateStart] = useState('');
  const [taskDateEnd, setTaskDateEnd] = useState('');

  // Stats for dashboard
  const [stats, setStats] = useState({
    urgentCount: 0,
    importantCount: 0,
    completedCount: 0,
    assignedCount: 0
  });

  // Form state
  const [formData, setFormData] = useState({
    taskTitle: '',
    taskDescription: '',
    taskDate: new Date().toISOString().split('T')[0],
    taskTime: '',
    taskPriority: 'normal',
    taskCategory: 'academic',
    taskAssignee: ''
  });

  useEffect(() => {
    updateStats();
  }, [tasks]);

  const updateStats = () => {
    const today = new Date().toISOString().split('T')[0];
    const urgentTasks = tasks.filter(task => task.priority === 'urgent' && task.status !== 'completed').length;
    const importantTasks = tasks.filter(task => task.priority === 'important' && task.status !== 'completed').length;
    const completedToday = tasks.filter(task => task.date === today && task.status === 'completed').length;
    const assignedTasks = tasks.filter(task => task.assignee !== 'self' && task.status !== 'completed').length;

    setStats({
      urgentCount: urgentTasks,
      importantCount: importantTasks,
      completedCount: completedToday,
      assignedCount: assignedTasks
    });
  };

  const previousMonth = () => {
    setCurrentDate(prev => {
      const newDate = new Date(prev);
      newDate.setMonth(newDate.getMonth() - 1);
      return newDate;
    });
  };

  const nextMonth = () => {
    setCurrentDate(prev => {
      const newDate = new Date(prev);
      newDate.setMonth(newDate.getMonth() + 1);
      return newDate;
    });
  };

  const selectDate = (dateStr) => {
    setSelectedDate(new Date(dateStr));
    setFormData(prev => ({...prev, taskDate: dateStr}));
    openTaskModal();
  };

  const openTaskModal = () => {
    setModalTitle('Add New Task');
    setEditingTaskId(null);
    setFormData({
      taskTitle: '',
      taskDescription: '',
      taskDate: new Date().toISOString().split('T')[0],
      taskTime: '',
      taskPriority: 'normal',
      taskCategory: 'academic',
      taskAssignee: ''
    });
    setShowModal(true);
  };

  const closeTaskModal = () => {
    setShowModal(false);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({...prev, [id]: value}));
  };

  const saveTask = (e) => {
    e.preventDefault();

    const assigneeSelect = document.getElementById('taskAssignee');
    const assigneeName = assigneeSelect.options[assigneeSelect.selectedIndex].text;

    if (editingTaskId) {
      // Update existing task
      setTasks(prevTasks =>
        prevTasks.map(task =>
          task.id === editingTaskId
            ? {
                ...task,
                title: formData.taskTitle,
                description: formData.taskDescription,
                date: formData.taskDate,
                time: formData.taskTime,
                priority: formData.taskPriority,
                category: formData.taskCategory,
                assignee: formData.taskAssignee,
                assigneeName: assigneeName === 'Select staff member...' ? 'Unassigned' : assigneeName
              }
            : task
        )
      );
    } else {
      // Add new task
      const newTask = {
        id: Date.now(),
        title: formData.taskTitle,
        description: formData.taskDescription,
        date: formData.taskDate,
        time: formData.taskTime,
        priority: formData.taskPriority,
        category: formData.taskCategory,
        assignee: formData.taskAssignee,
        assigneeName: assigneeName === 'Select staff member...' ? 'Unassigned' : assigneeName,
        status: 'pending'
      };

      setTasks(prev => [...prev, newTask]);
    }

    closeTaskModal();
  };

  const editTask = (taskId) => {
    const task = tasks.find(t => t.id === taskId);
    if (!task) return;

    setModalTitle('Edit Task');
    setEditingTaskId(taskId);
    setFormData({
      taskTitle: task.title,
      taskDescription: task.description,
      taskDate: task.date,
      taskTime: task.time || '',
      taskPriority: task.priority,
      taskCategory: task.category,
      taskAssignee: task.assignee
    });

    setShowModal(true);
  };

  const completeTask = (taskId) => {
    setTasks(prevTasks =>
      prevTasks.map(task =>
        task.id === taskId ? { ...task, status: 'completed' } : task
      )
    );
  };

  const deleteTask = (taskId) => {
    if (window.confirm('Are you sure you want to delete this task?')) {
      setTasks(prevTasks => prevTasks.filter(t => t.id !== taskId));
    }
  };

  // Helper functions
  const getPriorityColor = (priority) => {
    const colors = {
      urgent: 'bg-red-100 text-red-800',
      important: 'bg-amber-100 text-amber-800',
      normal: 'bg-green-100 text-green-800',
      low: 'bg-gray-100 text-gray-800'
    };
    return colors[priority] || colors.normal;
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-100 text-yellow-800',
      'in-progress': 'bg-blue-100 text-blue-800',
      completed: 'bg-green-100 text-green-800'
    };
    return colors[status] || colors.pending;
  };

  const getCategoryIcon = (category) => {
    const icons = {
      academic: '📚',
      administrative: '📋',
      staff: '👥',
      student: '🎓',
      facilities: '🏢',
      events: '🎉',
      meetings: '💼'
    };
    return icons[category] || '📋';
  };

  // Calendar generation
  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const monthName = currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Empty cells for days before the first day of the month
    const emptyCells = Array(firstDay).fill(null).map((_, i) => (
      <div key={`empty-${i}`} className="h-24 border border-gray-100"></div>
    ));

    // Generate days
    const days = Array(daysInMonth).fill(null).map((_, i) => {
      const day = i + 1;
      const currentDateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const dayTasks = tasks.filter(task => task.date === currentDateStr);
      const today = new Date().toISOString().split('T')[0];
      const isToday = currentDateStr === today;

      return (
        <div
          key={`day-${day}`}
          className={`h-24 border border-gray-100 p-2 cursor-pointer calendar-day bg-white hover:bg-blue-50 rounded-lg ${
            isToday ? 'bg-blue-100 border-blue-300' : ''
          }`}
          onClick={() => selectDate(currentDateStr)}
        >
          <div className="font-semibold text-gray-800 mb-1">{day}</div>
          <div className="space-y-1">
            {dayTasks.slice(0, 2).map(task => (
              <div
                key={task.id}
                className={`text-xs px-2 py-1 rounded priority-${task.priority} bg-white text-gray-700 truncate`}
              >
                {task.title}
              </div>
            ))}
            {dayTasks.length > 2 &&
              <div className="text-xs text-gray-500">+{dayTasks.length - 2} more</div>
            }
          </div>
          {dayTasks.length > 0 &&
            <div className="task-tooltip">
              <div className="font-semibold text-gray-800 mb-3 border-b pb-2">
                📅 {new Date(currentDateStr).toLocaleDateString('en-IN', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long'
                })}
              </div>
              <div className="space-y-3 max-h-64 overflow-y-auto">
                {dayTasks.map(task => (
                  <div key={task.id} className={`border-l-3 priority-${task.priority} pl-3`}>
                    <div className="flex justify-between items-start mb-1">
                      <h5 className="font-medium text-sm text-gray-800">{task.title}</h5>
                      <span className={`text-xs px-2 py-1 rounded-full ${getPriorityColor(task.priority)}`}>
                        {task.priority.toUpperCase()}
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 mb-2">{task.description}</p>
                    <div className="flex justify-between items-center text-xs text-gray-500">
                      <span>⏰ {task.time || 'No time'}</span>
                      <span className={`text-xs px-2 py-1 rounded ${getStatusColor(task.status)}`}>
                        {task.status.replace('-', ' ').toUpperCase()}
                      </span>
                    </div>
                    <div className="text-xs text-gray-600 mt-1">
                      👤 {task.assigneeName}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
        </div>
      );
    });

    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">School Calendar</h2>
          <div className="flex items-center space-x-4">
            <button onClick={previousMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
              <span className="text-gray-600">←</span>
            </button>
            <h3 className="text-lg font-semibold text-gray-700">{monthName}</h3>
            <button onClick={nextMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
              <span className="text-gray-600">→</span>
            </button>
          </div>
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-7 gap-2 mb-4">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, i) => (
            <div key={`header-${i}`} className="text-center font-semibold text-gray-600 py-2">{day}</div>
          ))}
        </div>
        <div className="grid grid-cols-7 gap-2">
          {emptyCells}
          {days}
        </div>
      </div>
    );
  };

  // Render today's tasks
  const renderTodaysTasks = () => {
    const today = new Date().toISOString().split('T')[0];
    const todayTasks = tasks.filter(task => task.date === today);

    if (todayTasks.length === 0) {
      return <p className="text-gray-500 text-center py-8">No tasks scheduled for today</p>;
    }

    return todayTasks.map(task => (
      <div key={task.id} className={`task-item priority-${task.priority} bg-white p-4 rounded-lg shadow-sm`}>
        <div className="flex justify-between items-start mb-2">
          <h4 className="font-semibold text-gray-800">{task.title}</h4>
          <span className={`text-xs px-2 py-1 rounded-full ${getPriorityColor(task.priority)}`}>
            {task.priority.toUpperCase()}
          </span>
        </div>
        <p className="text-sm text-gray-600 mb-2">{task.description}</p>
        <div className="flex justify-between items-center text-xs text-gray-500">
          <span>⏰ {task.time || 'No time set'}</span>
          <span>👤 {task.assigneeName}</span>
        </div>
        <div className="mt-3 flex space-x-2">
          <button
            onClick={() => editTask(task.id)}
            className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded-full hover:bg-blue-200 transition-colors"
          >
            Edit
          </button>
          <button
            onClick={() => completeTask(task.id)}
            className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full hover:bg-green-200 transition-colors"
          >
            Complete
          </button>
        </div>
      </div>
    ));
  };

  // Render upcoming tasks table
  const renderUpcomingTasks = () => {
    const today = new Date();
    const upcomingTasks = tasks
      .filter(task => new Date(task.date) >= today)
      .filter(task => !taskSearch || task.title.toLowerCase().includes(taskSearch.toLowerCase()))
      .filter(task => !taskPriorityFilter || task.priority === taskPriorityFilter)
      .filter(task => !taskStatusFilter || task.status === taskStatusFilter)
      .filter(task => !taskAssigneeFilter || task.assigneeName === taskAssigneeFilter)
      .filter(task => !taskDateStart || task.date >= taskDateStart)
      .filter(task => !taskDateEnd || task.date <= taskDateEnd)
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    if (upcomingTasks.length === 0) {
      return (
        <tr>
          <td colSpan={6} className="py-8 px-4 text-center text-gray-500">No tasks match your filters</td>
        </tr>
      );
    }

    return upcomingTasks.map(task => (
      <tr key={task.id} className="border-b border-gray-100 hover:bg-gray-50">
        <td className="py-3 px-4">
          <div className="font-medium">{new Date(task.date).toLocaleDateString()}</div>
          <div className="text-sm text-gray-500">{task.time || 'No time'}</div>
        </td>
        <td className="py-3 px-4">
          <div className="font-medium text-gray-800">{task.title}</div>
          <div className="text-sm text-gray-600">{task.description}</div>
          <div className="text-xs text-gray-500 mt-1">{getCategoryIcon(task.category)} {task.category}</div>
        </td>
        <td className="py-3 px-4">
          <span className={`px-2 py-1 text-xs rounded-full ${getPriorityColor(task.priority)}`}>
            {task.priority.toUpperCase()}
          </span>
        </td>
        <td className="py-3 px-4">
          <div className="text-sm font-medium">{task.assigneeName}</div>
        </td>
        <td className="py-3 px-4">
          <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(task.status)}`}>
            {task.status.replace('-', ' ').toUpperCase()}
          </span>
        </td>
        <td className="py-3 px-4">
          <div className="flex space-x-2">
            <button
              onClick={() => editTask(task.id)}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              Edit
            </button>
            <button
              onClick={() => deleteTask(task.id)}
              className="text-red-600 hover:text-red-800 text-sm"
            >
              Delete
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen font-sans">
        {/* Header */}
        <header className="bg-white shadow-lg border-b-4 border-orange-600">
          <div className="w-full px-6 py-4">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Principal's Dashboard</h1>
                <p className="text-gray-600 mt-1">Bharatiya Vidyalaya Senior Secondary School - Academic Year 2024-25</p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="text-right">
                  <p className="text-sm text-gray-600">Welcome back,</p>
                  <p className="font-semibold text-gray-800">Dr. Priya Sharma</p>
                </div>
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  PS
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="w-full px-6 py-8">
          {/* Quick Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-red-500 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Urgent Tasks</p>
                  <p className="text-3xl font-bold text-red-600 mt-2">{stats.urgentCount}</p>
                  <p className="text-xs text-gray-500 mt-1">Requires immediate attention</p>
                </div>
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center">
                  <span className="text-red-600 text-2xl">⚠️</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Important Tasks</p>
                  <p className="text-3xl font-bold text-orange-600 mt-2">{stats.importantCount}</p>
                  <p className="text-xs text-gray-500 mt-1">High priority items</p>
                </div>
                <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center">
                  <span className="text-orange-600 text-2xl">📋</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-green-500 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Completed Today</p>
                  <p className="text-3xl font-bold text-green-600 mt-2">{stats.completedCount}</p>
                  <p className="text-xs text-gray-500 mt-1">Tasks accomplished</p>
                </div>
                <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 text-2xl">✅</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Staff Assigned</p>
                  <p className="text-3xl font-bold text-blue-600 mt-2">{stats.assignedCount}</p>
                  <p className="text-xs text-gray-500 mt-1">Delegated responsibilities</p>
                </div>
                <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 text-2xl">👥</span>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Calendar Section */}
            <div className="lg:col-span-2">
              {renderCalendar()}
            </div>

            {/* Today's Tasks */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-800">Today's Tasks</h2>
                <button
                  onClick={openTaskModal}
                  className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
                >
                  + Add Task
                </button>
              </div>

              <div className="space-y-3">
                {renderTodaysTasks()}
              </div>
            </div>
          </div>

          {/* Upcoming Tasks Section */}
          <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Upcoming Tasks & Events</h2>

            {/* Table filters (independent of the Add Task modal form) */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
                <input
                  type="text"
                  value={taskSearch}
                  onChange={e => setTaskSearch(e.target.value)}
                  placeholder="Search task or event..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Priority</label>
                <select
                  value={taskPriorityFilter}
                  onChange={e => setTaskPriorityFilter(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="">All Priorities</option>
                  <option value="urgent">Urgent</option>
                  <option value="important">Important</option>
                  <option value="normal">Normal</option>
                  <option value="low">Low</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <select
                  value={taskStatusFilter}
                  onChange={e => setTaskStatusFilter(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="">All Status</option>
                  <option value="pending">Pending</option>
                  <option value="in-progress">In Progress</option>
                  <option value="completed">Completed</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Assigned To</label>
                <select
                  value={taskAssigneeFilter}
                  onChange={e => setTaskAssigneeFilter(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="">All Assignees</option>
                  {[...new Set(tasks.map(task => task.assigneeName).filter(Boolean))].map(name => (
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
                <div className="flex items-center gap-2">
                  <input
                    type="date"
                    value={taskDateStart}
                    onChange={e => setTaskDateStart(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                  <input
                    type="date"
                    value={taskDateEnd}
                    onChange={e => setTaskDateEnd(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>
              </div>
            </div>
            {(taskSearch || taskPriorityFilter || taskStatusFilter || taskAssigneeFilter || taskDateStart || taskDateEnd) && (
              <button
                onClick={() => { setTaskSearch(''); setTaskPriorityFilter(''); setTaskStatusFilter(''); setTaskAssigneeFilter(''); setTaskDateStart(''); setTaskDateEnd(''); }}
                className="mb-4 text-sm text-orange-600 hover:underline font-medium"
              >
                Clear filters
              </button>
            )}

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Date</th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Task/Event</th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Priority</th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Assigned To</th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Status</th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-700">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {renderUpcomingTasks()}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Task Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 modal-backdrop flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{modalTitle}</h3>
                <button onClick={closeTaskModal} className="text-gray-500 hover:text-gray-700 text-2xl">×</button>
              </div>

              <form onSubmit={saveTask}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Task Title</label>
                    <input
                      type="text"
                      id="taskTitle"
                      value={formData.taskTitle}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                    <textarea
                      id="taskDescription"
                      value={formData.taskDescription}
                      onChange={handleInputChange}
                      rows="3"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    ></textarea>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
                    <input
                      type="date"
                      id="taskDate"
                      value={formData.taskDate}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Time</label>
                    <input
                      type="time"
                      id="taskTime"
                      value={formData.taskTime}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Priority</label>
                    <select
                      id="taskPriority"
                      value={formData.taskPriority}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    >
                      <option value="urgent">🔴 Urgent</option>
                      <option value="important">🟡 Important</option>
                      <option value="normal">🟢 Normal</option>
                      <option value="low">⚪ Low</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
                    <select
                      id="taskCategory"
                      value={formData.taskCategory}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    >
                      <option value="academic">📚 Academic</option>
                      <option value="administrative">📋 Administrative</option>
                      <option value="staff">👥 Staff Management</option>
                      <option value="student">🎓 Student Affairs</option>
                      <option value="facilities">🏢 Facilities</option>
                      <option value="events">🎉 Events</option>
                      <option value="meetings">💼 Meetings</option>
                    </select>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Assign To</label>
                    <select
                      id="taskAssignee"
                      value={formData.taskAssignee}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    >
                      <option value="">Select staff member...</option>
                      <option value="self">👤 Handle Personally</option>
                      <optgroup label="Heads of Department">
                        <option value="hod-english">📖 Dr. Rajesh Kumar - English HOD</option>
                        <option value="hod-math">🔢 Prof. Anita Gupta - Mathematics HOD</option>
                        <option value="hod-science">🔬 Dr. Vikram Singh - Science HOD</option>
                        <option value="hod-social">🌍 Mrs. Meera Joshi - Social Studies HOD</option>
                        <option value="hod-arts">🎨 Ms. Kavya Nair - Arts HOD</option>
                      </optgroup>
                      <optgroup label="Administrative Staff">
                        <option value="admin-registrar">📋 Mrs. Sunita Verma - Registrar</option>
                        <option value="admin-counselor">💭 Dr. Arjun Patel - School Counselor</option>
                        <option value="admin-librarian">📚 Ms. Deepika Sharma - Head Librarian</option>
                        <option value="admin-nurse">🏥 Mrs. Ritu Agarwal - School Nurse</option>
                      </optgroup>
                      <optgroup label="Support Staff">
                        <option value="facilities-manager">🔧 Mr. Suresh Yadav - Facilities Manager</option>
                        <option value="it-coordinator">💻 Ms. Neha Kapoor - IT Coordinator</option>
                        <option value="sports-coordinator">⚽ Coach Rohit Sharma - Sports Coordinator</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end space-x-4 mt-8">
                  <button
                    type="button"
                    onClick={closeTaskModal}
                    className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium transition-colors"
                  >
                    Save Task
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PrincipalDashboard;